export default {
  "foot": {
    "title": "Century Games Spieler",
    "p1": "Gib deine Benutzer-ID ein und bezahle die Aufladung. Der Betrag wird direkt in deinem verknüpften Konto aktualisiert. Wenn er nicht angezeigt wird, bitte lade das Spiel neu oder wende dich bei Bedarf an den Kundenservice.",
    "p2": "Wenn du irgendwelche Fragen hast, kannst du dich gerne an den Kundenservice wenden. Vielen Dank für deine Unterstützung!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "Nutzungsbedingungen",
    "policy": "Datenschutzrichtlinie",
    "descriptionTitle": "Wie Funktioniert Das?"
  },
  "accept": {
    "title": "Diese Website verwendet Cookies, um dein Surferlebnis zu verbessern. Bitte lies unsere <a href=\"https://www.centurygames.com/privacy-policy/\" style=\"color: #58a8a5;\">Datenschutzrichtlinie</a>, um Informationen darüber zu erhalten, was wir auf unserer Website sammeln. Indem du diese Website weiterhin nutzt, stimme zu, dass wir Cookies auf deinem Gerät speichern und darauf zugreifen können.",
    "decline": "Ablehnen",
    "accept": "Akzeptieren"
  },
  "game": {
    "inapptext": "Oder melde dich über das Spiel an",
    "loginfail": "Anmeldung Fehlgeschlagen",
    "logintip": "Wenn das Spiel nicht autorisiert werden konnte, aktualisiere das Spiel bitte auf die neueste Version oder versuche einen anderen Browser.",
    "reloadmsg": "Bitte tippe auf \"Neu laden\", um das Anmeldeergebnis zu erhalten.",
    "reload": "Neu laden",
    "appnotice": "Wenn du dich über die Spiele-App anmelden möchtest, verwende bitte einen externen Browser, um den Store zu öffnen.",
    "changeaccount": "Bist du sicher, dass du dich von deinem Konto abmelden möchtest?",
    "login": "Anmelden",
    "notice": "Hinweis",
    "confirm": "Bestätigen",
    "loginuserid": "Benutzer-ID",
    "palceholder": "Gib Benutzer-ID ein",
    "okbtn": "OK",
    "loginbtn": "Melde dich über das Spiel an",
    "changebtn": "Oder melde dich mit der Benutzer-ID an",
    "useTitle": "KONTO",
    "checkBtn": "Prüfen",
    "findid": "Du konntest deine Benutzer-ID nicht finden?",
    "checktext": "Tippe in den Einstellungen auf das Fragezeichen, um weitere Informationen zu erhalten.",
    "username": "Spitzname:",
    "userId": "Benutzer-ID:",
    "packageTitle": "AUFLADUNGSBETRAG",
    "edit": "Bearbeiten",
    "paymentTitle": "ZAHLUNGSART",
    "total": "Insgesamt",
    "goPay": "Jetzt Spielen",
    "noSelectPackageTips": "Du hast keinen Betrag ausgewählt",
    "payFail": "ZAHLUNG FEHLGESCHLAGEN",
    "camelPayfail": "Zahlung Fehlgeschlagen",
    "payFailTips1": "Bitte kontaktiere den Adyen-Kundenservice",
    "payFailTips2": "Bitte kontaktiere den PayPal-Kundenservice",
    "paySuccess": "ZAHLUNG ERFROLGREICH",
    "paySuccessTips2": "Lade das Spiel erst neu, bevor du dich an den Kundenservice wendest, weil du deinen Kauf nicht erhalten hast!",
    "camelPaySuccess": "Zahlung erfolgreich",
    "transactionId": "Transaktions-ID",
    "paySuccessTips": "Die Lieferung des Artikels kann einen Moment dauern, bitte warte.",
    "deliveryFail": "LIEFERUNG FEHLGESCHLAGEN",
    "deliveryFailTips": "Bitte kontaktiere den Kundenservice",
    "orderTitle": "Zusammenfassung deiner Bestellung",
    "paidWith": "Zahlungsmethode",
    "orderID": "Transaktions-ID",
    "payStatus": "Status der Zahlung",
    "orderTotal": "Gesamtpreis",
    "transactionDate": "Transaktionsdatum",
    "goOnPay": "Erneuter Kauf",
    "getInvoice": "Quittung",
    "camelDeliveryFail": "Lieferung fehlgeschlagen",
    "confirmOrder": "AUFTRAGSBESTÄTIGUNG",
    "confirmFollow": "Bitte bestätige die folgenden Angaben:",
    "nickname": "Spitzname",
    "packageName": "Artikel",
    "totalPayment": "Gesamtpreis",
    "confirmPayWith": "Zahlungsmethode",
    "confirmAndGoOn": "Bestätigen und mit der Zahlung fortfahren",
    "orderCancel": "Abbrechen",
    "getInvoiceTitle": "VIA EMAIL SENDEN",
    "getInvoiceTips": "Wenn du die Quittung per E-Mail erhalten möchtest, gib bitte eine E-Mail-Adresse an.",
    "getInvoiceTips1": "Bitte gib deine E-Mail-Adresse ein, um die Quittung zu erhalten",
    "getInvoiceTips2": "Zustimmen, dass wir deine E-Mail-Adresse erfassen und speichern.",
    "getInvoiceTips3": "Zustimmen, E-Mails über Rabatte, Aktionen und mehr für unsere Spiele per E-Mail zu erhalten.",
    "invoiceSend": "Senden",
    "sendSuccess": "Quittung per E-Mail gesendet",
    "id404": "Benutzer-ID nicht gefunden",
    "packageLoadingText": "Artikel im Shop aktualisieren ...",
    "taxTips": "Preis inklusive Steuern",
    "adyenTips": "Der Zahlungsdienst wird von Adyen bereitgestellt, das über eine Banklizenz verfügt und von der niederländischen Zentralbank beaufsichtigt wird. Wenn du Fragen zu den Zertifizierungen hast, lies bitte <<a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>. Informationen zum Schutz deiner Daten findest du unter <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>.",
    "paypalTips": "Der Zahlungsdienst wird von PayPal bereitgestellt. Informationen zum Schutz deiner Daten findest du unter <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>",
    "switchCountryTips": "Dein bevorzugtes Land/deine bevorzugte Region ist ${servercountry}. Möchtest du Land und Währung ändern?",
    "paypalBtn": "Jetzt mit Karte bezahlen",
    "paypalOr": "Oder",
    "paypalCard1": "Name des Karteninhabers (optional)",
    "paypalCard2": "Kartennummer",
    "checkUserID": "Link",
    "success": "ERFOLG",
    "changeCurrencyContent": "Möchtest du die Region und die Währung so ändern, dass sie deiner Einstellung im Spiel entsprechen: ${servercountry}？",
    "productDescription": "Farm Taler sind Zahlungsmittel, die zum Kauf von Paketen und Angeboten im Spiel verwendet werden können.",
    "payButton": "KAUFEN",
    "userIdNotice": "Bitte gib zuerst deine Benutzer-ID ein, um dein Spielkonto zu verknüpfen.",
    "account": "Konto",
    "card": "Karte",
    "notification": "Gib deine Benutzer-ID ein, um dein Konto zu verknüpfen, wähle die gewünschten Gegenstände aus und bezahle mit deiner bevorzugten Zahlungsmethode. Nach dem Neuladen des Spiels werden die gekauften Gegenstände in deinem Konto angezeigt und können verwendet werden.\n\nWenn du Fragen hast, wende dich bitte an den Kundenservice im Spiel.",
    "rongluRank": "Ofen Level:",
    "tips": "Wie wird es verwendet?",
    "checkTIps1": "Ich habe die <a :href=\"policyUrl\">\"Datenschutzrichtlinie\"</a>, <a :href=\"serviceURl\">\"Servicebedingungen\"</a> und <a :href=\"paymentURl\">\"Zahlungsbedingungen\"</a> gelesen und stimme ihnen zu.",
    "checkTIps2": "Bitte lesen und ankreuzen",
    "selectTips": "(Die Währung des letzten Kaufs im Spiel wird ausgewählt)",
    "koPayTips": "Wenn deine Bankkarte den koreanischen Won als Fremdwährung verwendet, wird der Dynamic Currency Conversion (DCC) Service verwendet, und eine zusätzliche Bearbeitungsgebühr kann von einem Drittanbieter und nicht von dieser Website erhoben werden.",
    "PayTips": ""
  },
  "invoice": {
    "title": "Quittung",
    "transactionId": "Transaktions-ID",
    "transactionDate": "Datum der Transaktion",
    "totalAmount": "Gesamtbetrag",
    "paymentMethod": "Zahlungsmethode",
    "description": "Beschreibung",
    "game": "Spiel",
    "quantity": "Menge",
    "price": "Preis",
    "amount": "Betrag",
    "total": "Gesamtbetrag",
    "footTitle": "Anmerkungen",
    "footContent": "Danke, dass du Century Games unterstützt!",
    "button1": "Erhalte Quittung",
    "button2": "Zurück ohne Quittung",
    "giveupInvoice": "Du wirst keine Quittung für die Bestellung erhalten. Bestätigen?"
  },
  "payment": {
    "card": "Kreditkarte / Debitkarte",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "LAND / REGION",
    "Africa": "Afrika",
    "America": "Amerika",
    "Asia": "Asien",
    "Europe": "Europa",
    "Oceania": "Ozeanien",
    "ZA": "Südliches Afrika",
    "US": "Vereinigte Staaten",
    "HK": "Hongkong, China",
    "JP": "Japan",
    "KR": "Korea",
    "SG": "Singapur",
    "SA": "Saudi-Arabien",
    "IQ": "Irak",
    "TW": "Taiwan, China",
    "TH": "Thailand",
    "GB": "Vereinigtes Königreich",
    "AU": "Australien",
    "countryLanguage1": "SPRACHE",
    "AE": "Vereinigte Arabische Emirate",
    "DE": "Deutschland",
    "PT": "Portugal",
    "RU": "Russland",
    "ES": "Spanien",
    "CH": "Schweiz",
    "TR": "Türkei",
    "KW": "Kuwait",
    "QA": "Katar",
    "PL": "Polen",
    "ID": "Indonesien",
    "IT": "Italien",
    "IN": "Indien",
    "FR": "Frankreich",
    "CA": "Kanada",
    "NL": "Niederlande",
    "AT": "Österreich",
    "RS": "Serbien",
    "SE": "Schweden",
    "MY": "Malaysia",
    "BE": "Belgien",
    "DK": "Dänemark",
    "FI": "Finnland",
    "PH": "Philippinen",
    "NO": "Norwegen",
    "BR": "Brasilien",
    "NZ": "Neuseeland",
    "UA": "Ukraine",
    "RO": "Rumänien"
  },
  "extra_info": {
    "kingdom": "Region: #"
  },
  "adyen": {
    "note": "Der Zahlungsdienst wird von Adyen bereitgestellt und bietet sichere Transaktionen mit dem höchsten Level der PCI-DSS-Zertifizierung von internationalen Kreditkartenorganisationen, die sowohl inländische als auch ausländische Kartenzahlungen unterstützen.",
    "note2": "Hinweis: Mit der Option „Für meine nächste Zahlung speichern“ kannst du die Daten deiner Zahlungskarte in deinem aktuellen Browser für zukünftige Zahlungen speichern."
  },
  "pay": {
    "error1": "Wenn etwas schief geht, versuche es bitte später noch einmal oder verwende eine andere Zahlungsmethode. Bitte kontaktiere den Kundensupport, wenn du weitere Fragen hast."
  },
  "meta": {
    "title": "Family Farm Adventure Laden",
    "description": "Der Family Farm Adventure Laden ist der offizielle Laden von Family Farm Adventure und bietet einen vergünstigten Aufladekanal und Pakete für Spieler.",
    "keywords": "Bauernhof, Anbau, Markt, Upgrade, Erkundung, Karte, Charakter, Level, Simulation, Strategie, Bezahlung, Laden, Aufladen, Bezahlung"
  }
};


// WEBPACK FOOTER //
// ./src/lang/DE.js